import { Box, Button, IconButton, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { ENDPOINTS, getApiUrl } from "../../../common/endpoints";
import { useDecks } from "../../../hooks/decks.hook";
import SelectDeck from "../../../components/SelectDeck";
import { Requests } from "../../../common/requests";
import { useSnackbar } from "notistack";
import { DataCodeEnum } from "../../../constants/enum";
import ViewDetailDeck from "../components/ViewDetailDeck";
import TogglePublicBtn from "../../../components/TogglePublicBtn";
import { Delete } from "@mui/icons-material";
import { DECK_IMG_URL } from "../../../constants";
import _ from "lodash";

const OneCardTarotReading = () => {
  const { enqueueSnackbar } = useSnackbar();
  const { decks } = useDecks();
  const [data, setData] = useState<any>(null);
  const [deckActive, setDeckActive] = useState<any>(null);
  const [selectedDecks, setSelectedDecks] = useState<any[]>([]);

  const fetchData = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(
        ":dataCode",
        DataCodeEnum.ONE_CARD_TAROT_DECK
      )
    );
    try {
      const data = await Requests.get(apiUrl);
      if (data.content) {
        setData(data);
        if (Array.isArray(data.content)) {
          setSelectedDecks(data.content);
        } else {
          setSelectedDecks([data.content]);
        }
      }
    } catch (e) {}
  };

  useEffect(() => {
    fetchData();
  }, []);

  const onSave = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.SAVE_PAGE_CONTENT.replace(
        ":dataCode",
        DataCodeEnum.ONE_CARD_TAROT_DECK
      )
    );

    try {
      await Requests.post(apiUrl, {
        dataName: "One card tarot",
        content: selectedDecks,
      });
      fetchData();
      enqueueSnackbar("Save successfully!", { variant: "success" });
    } catch (e) {
      enqueueSnackbar("Save unsuccessfully!", { variant: "error" });
    }
  };

  const onTogglePublish = async () => {
    const apiUrl = getApiUrl(
      ENDPOINTS.TOGGLE_PUBLISH_PAGE_CONTENT.replace(
        ":dataCode",
        DataCodeEnum.ONE_CARD_TAROT_DECK
      )
    );

    try {
      const data = await Requests.patch(apiUrl, {});
      fetchData();
      enqueueSnackbar("Toggle publish success!", { variant: "success" });
    } catch (e) {}
  };

  return (
    <Box
      sx={{
        padding: "10px",
      }}
    >
      <Box
        sx={{
          padding: "10px",
        }}
      >
        <Typography
          color="primary"
          sx={{
            fontWeight: "bold",
            fontSize: "24px",
          }}
        >
          One Card Tarot Reading
        </Typography>
      </Box>
      <Box
        sx={{
          display: "flex",
        }}
      >
        <Box
          sx={{
            padding: "10px",
            display: "flex",
            flexDirection: "column",
            alignItems: "flex-start",
          }}
        >
          <Typography
            sx={{
              fontSize: 14,
            }}
          >
            Choose decks to use for daily card
          </Typography>
          <SelectDeck
            decks={decks}
            onChangeDeck={(value: any) => {
              setSelectedDecks((prev) => _.uniqBy([...prev, value], "id"));
            }}
          />
          <Box
            sx={{
              maxHeight: "calc(100vh - 220px)",
              overflowY: "auto",
            }}
          >
            {selectedDecks.map((deck) => {
              return (
                <Box
                  sx={{
                    display: "flex",
                    padding: "8px",
                    width: "240px",
                    borderBottom: "1px solid #ccc",
                  }}
                  onClick={() => setDeckActive(deck)}
                >
                  <img
                    src={DECK_IMG_URL.replace("DECK_ID", deck.id)}
                    alt={deck.title}
                    style={{ height: "40px" }}
                  />
                  <Typography
                    sx={{
                      marginLeft: "10px",
                      fontSize: "14px",
                      flex: 1,
                    }}
                  >
                    {deck.title}
                  </Typography>
                  <IconButton
                    onClick={(event) => {
                      event.stopPropagation();
                      setSelectedDecks((prev) =>
                        prev.filter((item) => item.id !== deck.id)
                      );
                    }}
                  >
                    <Delete />
                  </IconButton>
                </Box>
              );
            })}
          </Box>
          <Box
            sx={{
              display: "flex",
              padding: "10px 0",
            }}
          >
            <Button
              variant="contained"
              color="primary"
              sx={{
                textTransform: "unset",
                marginRight: "10px",
              }}
              onClick={() => {
                onSave();
              }}
              // disabled={!deck || deck?.id === data?.content?.id}
            >
              Save
            </Button>
            <TogglePublicBtn
              isValidated={!!data?.ispublished}
              onToggle={() => {
                onTogglePublish();
              }}
            />
          </Box>
        </Box>
        {deckActive && (
          <Box
            sx={{
              maxHeight: "calc(100vh - 100px)",
              overflowY: "auto",
              flex: 1,
            }}
          >
            <ViewDetailDeck deck={deckActive} />
          </Box>
        )}
      </Box>
    </Box>
  );
};

export default OneCardTarotReading;
